import { render, staticRenderFns } from "./RankingSKPD.vue?vue&type=template&id=5aea8bff&scoped=true&lang=html&"
import script from "./RankingSKPD.vue?vue&type=script&lang=js&"
export * from "./RankingSKPD.vue?vue&type=script&lang=js&"
import style0 from "./RankingSKPD.vue?vue&type=style&index=0&id=5aea8bff&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea8bff",
  null
  
)

export default component.exports